const TOKEN_KEY = 'guardian_token'
const EXPIRES_KEY = 'guardian_token_expires'

export const getToken = (): string | null => localStorage.getItem(TOKEN_KEY)

export const setToken = (token: string, expiresAt?: string) => {
  localStorage.setItem(TOKEN_KEY, token)
  if (expiresAt) {
    localStorage.setItem(EXPIRES_KEY, expiresAt)
  } else {
    localStorage.removeItem(EXPIRES_KEY)
  }
}

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(EXPIRES_KEY)
}

export const isAuthenticated = (): boolean => {
  const token = getToken()
  if (!token) {
    return false
  }
  const expiresAt = localStorage.getItem(EXPIRES_KEY)
  if (expiresAt && new Date(expiresAt) < new Date()) {
    clearToken()
    return false
  }
  return true
}

export const isTurnstileConfigured = (): boolean =>
  Boolean(process.env.REACT_APP_TURNSTILE_SITE_KEY)
